<footer 
  class="custom-route-desktop__actions-footer-bar" 
  [class.is-loading-resources]="checkIfLoadingNewResources()"
>
  <app-route-days />
  
  <div class="actions-footer-bar__more-chatbot-container">
    <app-more />
    <app-chatbot-custom-route-desktop [chatID]="chatId()"/>
  </div>
</footer>
